import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import FloatingActions from './FloatingActions';
import EnquiryModal from '../EnquiryModal';

/** Jumps to the top on every route change (but respects in-page #anchors). */
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [pathname, hash]);

  return null;
}

export default function Layout() {
  return (
    <div className="flex min-h-screen flex-col">
      <ScrollToTop />
      <Header />
      {/* Offset for the fixed, opaque masthead. */}
      <main className="flex-1 pt-[76px] lg:pt-[96px]">
        <Outlet />
      </main>
      <Footer />
      <FloatingActions />
      <EnquiryModal />
    </div>
  );
}
